
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { Spedizione } from '@/models';
import dayjs, { Dayjs } from 'dayjs';
import { store, StoreMutations } from '@/store';
@Component
export default class ItemListSpedizione extends Vue {
    @Prop() public spedizione!: Spedizione;

    public showDetail(spedizione: Spedizione) {
        this.$router.push({ name: 'spedizione', params: { id: spedizione.id }});
    }

    public formatDateTime(date: Date): string {
        if (!date) return '';
        return dayjs(date).format('DD/MM/YYYY HH:mm');
    }
    public apriDDT()
    {
        window.open( 'ddt/' + this.spedizione.id , '_blank');
    }

    public setIdSpedizioneForDelete(id: string | null | undefined){
        store.commit(StoreMutations.SetIdSpedizioneForDelete, id);
    }
}
